import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import InventoryPage from "./pages/InventoryPage";
import CarDetailPage from "./pages/CarDetailPage";
import GalleryPage from "./pages/GalleryPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import ServicesPage from "./pages/ServicesPage";
import SellCarPage from "./pages/SellCarPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboard from "./pages/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

const withLayout = (el) => <Layout>{el}</Layout>;

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Toaster
          position="bottom-center"
          theme="dark"
          toastOptions={{
            style: {
              background: "#121212",
              border: "1px solid rgba(255,255,255,0.08)",
              color: "#F5F5DC",
            },
          }}
        />
        <Routes>
          <Route path="/" element={withLayout(<HomePage />)} />
          <Route path="/inventory" element={withLayout(<InventoryPage />)} />
          <Route path="/inventory/:id" element={withLayout(<CarDetailPage />)} />
          <Route path="/gallery" element={withLayout(<GalleryPage />)} />
          <Route path="/about" element={withLayout(<AboutPage />)} />
          <Route path="/contact" element={withLayout(<ContactPage />)} />
          <Route path="/services" element={withLayout(<ServicesPage />)} />
          <Route path="/sell" element={withLayout(<SellCarPage />)} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/*" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
